import { type FC } from "react";

import { storageEngine, TYPE } from "../utils/storage";
import { getAccountsData } from "../AccountSelection/AccountSelectionTabelView/api/GetAccountList";
import { useBooleanState } from "../common/hooks/useBooleanState";
import { userCanSeeMyCompanySettings } from "../AccountSettings/helper/permissions";
import { HOMEPAGE } from "../utils/url/staticUrls";
import { redirectToUrl } from "../utils/url/urlUtils";
import { OrderQuoteSettingsPage } from "./OrderQuoteSettingsPage";
import Spinner from "../common/components/Spinner/Spinner";
import { userIsLoggedIn } from "../utils/roles";

export function createOrderQuoteSettings() {
  return <OrderQuoteSettingsInit />;
}

const OrderQuoteSettingsInit: FC = () => {
  // guard route
  if (!userCanSeeMyCompanySettings || !userIsLoggedIn()) {
    redirectToUrl(HOMEPAGE);
    return null;
  }

  const { val: ready, setTrue } = useBooleanState(false);
  const accounts = storageEngine(TYPE.SESSION).getItem("userAccounts");
  // check again for accounts (in case Client didn't reach Select Account)
  if (null === accounts) {
    getAccountsData()
      .then((accounts) => {
        storageEngine(TYPE.SESSION).setItem("userAccounts", JSON.stringify(accounts.rows));
      })
      .finally(() => setTrue());
  }
  // check for ready is FALSE to prevent re-render loop after setTrue is called
  if (null !== accounts && !ready) {
    setTrue();
  }
  return ready ? <OrderQuoteSettingsPage /> : <Spinner />;
};
